import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import Layout from 'components/layout/Layout'
import Pricing from 'features/pricing/Pricing'
import { Language } from 'types/language'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import type { PricingPageProps } from 'features/pricing/types'
import type { SeoProps } from 'components/seo/types'
import { log } from 'utils/logging'
import { cmsLib, productsLib } from 'lib'
import { useTranslation } from 'next-i18next/pages'

const PricingPage = (props: PricingPageProps) => {
  // i18n
  const { t } = useTranslation('pricing')

  // Constants
  const seo: SeoProps = {
    title: t('seo.title'),
    description: t('seo.description'),
    image: props?.content?.seo?.metaImage?.url
  }

  return (
    <Layout {...{ seo }}>
      <Pricing {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  // Fetch products from API & CMS
  const [allProducts, content, products] = await Promise.all([
    productsLib.getProducts(),
    cmsLib.getPricingPage(locale || Language.DUTCH),
    cmsLib.getProductsContent(locale || Language.DUTCH)
  ])

  // Check if products are available
  if (products?.length === 0) {
    log({ error: 'No products found for pricing page', identifier: '[CMS:pricing:getStaticProps]' })

    return {
      notFound: true,
      revalidate: 5
    }
  }

  return {
    props: {
      allProducts,
      products,
      content,
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'pricing'], i18nConfig))
    },
    revalidate: 3600 * 24 // re-generate page when a request comes in, once every day
  }
}

export default PricingPage
